@if (isLoading) {
  <div class="meeting-mode__loading"><mat-spinner diameter="40"></mat-spinner></div>
} @else {
  <div class="meeting-mode">
    <div class="meeting-mode__bar">
      <button mat-button class="meeting-mode__back" (click)="backToList()">
        <mat-icon>chevron_left</mat-icon>{{ 'meetingMode.backToList' | translate }}
      </button>
      <span class="meeting-mode__count">
        {{ (meetingCount === 1 ? 'meetingMode.countOne' : 'meetingMode.count') | translate: {count: meetingCount} }}
      </span>
      <span class="meeting-mode__bar-spacer"></span>
      <button class="meeting-mode__chip" [class.meeting-mode__chip--on]="onlyOpenOffers"
              [attr.aria-pressed]="onlyOpenOffers"
              (click)="toggleOnlyOpen()">
        {{ 'meetingMode.onlyOpen' | translate }}
      </button>
      <app-ci-select
        class="meeting-mode__filter"
        variant="outline"
        [items]="buFilterOptions"
        [displayWith]="displayBuFilter"
        [label]="'meetingMode.buLabel' | translate"
        [ariaLabel]="'meetingMode.buAria' | translate"
        [searchPlaceholder]="'ciSelect.search' | translate"
        [searchClearLabel]="'ciSelect.clearSearch' | translate"
        [emptyLabel]="'ciSelect.noMatch' | translate"
        [hitTemplate]="'ciSelect.hits' | translate"
        [(ngModel)]="buFilter"
        (ngModelChange)="onFilterChange()"
      ></app-ci-select>
    </div>

    <div class="meeting-mode__intro">
      <h1 class="meeting-mode__title">{{ 'meetingMode.title' | translate }}</h1>
      <p class="meeting-mode__subtitle">
        {{ 'meetingMode.subtitle' | translate: {date: (today | date: 'dd.MM.yyyy')} }}
      </p>
    </div>

    @for (firm of orderedFirms; track firm) {
      <div class="meeting-mode__firm">
        <div class="meeting-mode__firm-head" role="button" tabindex="0"
             [attr.aria-expanded]="!isCollapsed(firm)"
             (click)="toggleFirm(firm)"
             (keydown.enter)="toggleFirm(firm)"
             (keydown.space)="$event.preventDefault(); toggleFirm(firm)">
          <mat-icon class="meeting-mode__chev" [class.meeting-mode__chev--open]="!isCollapsed(firm)">
            chevron_right
          </mat-icon>
          @if (firm) {
            <app-company-badge [abbreviation]="firm"></app-company-badge>
          } @else {
            <span class="meeting-mode__firm-tag">{{ 'meetingMode.noFirm' | translate }}</span>
          }
          <span class="meeting-mode__firm-count">
            {{ (entriesByFirm(firm).length === 1 ? 'meetingMode.firmCountOne' : 'meetingMode.firmCount') | translate: {count: entriesByFirm(firm).length} }}
          </span>
        </div>
        @if (!isCollapsed(firm)) {
          <div class="meeting-mode__list">
            @for (entry of entriesByFirm(firm); track entry.id) {
              <app-meeting-row [entry]="entry" [today]="today"></app-meeting-row>
            }
          </div>
        }
      </div>
    }

    @if (meetingCount === 0) {
      <div class="meeting-mode__empty">{{ 'meetingMode.empty' | translate }}</div>
    }
  </div>
}
